
import { VueSelecto } from "vue-selecto";
import { ScheduleRepository } from "@/modules/common-schedule/schedule.repository";
import { ScheduleRepository as Schedule } from "@/modules/schedule/schedule.repository.js";

import Vue from "vue";
import { mapState } from "vuex";
import EditDoctorModal from "./components/EditDoctorModal.vue";
import ScheduleAppointmentDetail from "@/modules/schedule/ScheduleAppointmentDetail.vue";

interface Doctor {
  id: number;
  name: string;
}
interface SheduleTime {
  disable: boolean;
  schedule: null | any;
  time: string;
  ts: number;
}
interface SheduleList {
  [key: string]: {
    date: string;
    day_number: string;
    day_short_title: string;
    items: {
      [key: string]: SheduleTime;
    };
  };
}
export default Vue.extend({
  components: { VueSelecto },

  props: {},

  data() {
    return {
      loading: false,
      doctorsList: [] as any[] | null,
      schedules: {} as SheduleList,
      week: 0,
      weekType: "",
      weekInfo: {
        day_start: "",
        day_end: "",
        month_start: "",
        month_end: "",
        year_start: "",
        year_end: "",
      },
      timeIntervals: [] as any[],
      currentDoctor: { id: 0, name: "" } as Doctor,
    };
  },

  computed: {
    ...mapState("auth", ["profile"]),

    allowEditOtherSchedules(): boolean {
      return this.profile.schedule_editor_flag;
    },
    allowEditOwnSchedule(): boolean {
      return this.profile.own_schedule_editor_flag;
    },
    profileDoctorId(): number | null {
      if (this.profile) {
        return this.profile.id;
      }
      return null;
    },
    isLargeScreen() {
      return window.innerWidth > 1024;
    },
  },

  async created() {
    if (this.profile) {
      await this.loadData(true);
    }
  },

  watch: {
    profileDoctorId(val) {
      if (val) {
        this.loadData(true);
      }
    },
  },

  methods: {
    async open(event) {
      const response = await Schedule.getAppointment(event.entity_id);

      if (response.success) {
        await this.$dialog.showAndWait(ScheduleAppointmentDetail, {
          width: "600px",
          appointment: response.data.data,
          calendarEvent: event,
        });
        this.loading = true;
      } else {
        this.$dialog.notify.error(response.message);
      }
    },
    editDoctor(doctorId) {
      this.$dialog.showAndWait(EditDoctorModal, { width: "600px", doctorId, persistent: true });
    },
    async loadData(getDoctors = false, newDoctor: Doctor | null = null) {
      this.loading = true;
      if (getDoctors) {
        this.currentDoctor = { id: this.profile.id, name: this.profile.name };
        const { data } = await this.$registry.get(ScheduleRepository).getDoctors();
        this.doctorsList = data;
      }
      if (newDoctor !== null) {
        this.currentDoctor = newDoctor;
      }

      const response = await this.$registry.get(ScheduleRepository).getCalendarByDoctor({
        week: this.week,
        weekType: this.weekType,
        doctorId: this.currentDoctor.id,
      });

      if (!response) {
        this.$dialog.notify.error("ошибка получения данных календаря");
        return;
      }

      this.schedules = response.schedules;
      this.week = response.week;
      this.weekInfo = response.week_info;
      this.timeIntervals = response.time_intervals;
      this.loading = false;
    },

    previousWeek() {
      this.weekType = "prev-week";
      this.loadData();
    },

    nextWeek() {
      this.weekType = "next-week";
      this.loadData();
    },

    /**
     * Открывает время на запись
     * @param interval
     */
    async openTime(interval, silent = false) {
      const { success, message } = await this.$registry
        .get(ScheduleRepository)
        .toggleTimeByDoctor(interval.ts, this.currentDoctor.id);
      if (success) {
        interval.schedule = {};
        if (!silent) {
          this.$dialog.notify.success(`Время ${interval.time} открыто для записи`);
        }
        return;
      }

      this.$dialog.notify.error(message);
    },

    /**
     * Закрывает время на запись
     * @param interval
     */
    async closeTime(interval, silent = false) {
      const { success, message } = await this.$registry
        .get(ScheduleRepository)
        .toggleTimeByDoctor(interval.ts, this.currentDoctor.id);
      if (success) {
        interval.schedule = null;
        if (!silent) {
          this.$dialog.notify.info(`Время ${interval.time} закрыто для записи`);
        }
        return;
      }

      this.$dialog.notify.error(message);
    },

    onSelect(e) {
      e.added.forEach(el => {
        el.classList.add("selecting");
      });
      e.removed.forEach(el => {
        el.classList.remove("selecting");
      });
    },

    onSelected(e) {
      const requestInfo = [] as SheduleTime[];
      e.selected.forEach(el => {
        el.classList.remove("selecting");
        const date: string = el.dataset.date;
        const time: string = el.dataset.time;
        if (el.dataset.time && el.dataset.date) {
          requestInfo.push(this.schedules[date].items[time]);
        }
      });
      this.toggleTime(requestInfo);
    },

    toggleTime(intervals) {
      intervals.forEach(interval => {
        if (!interval.disable && interval.schedule === null) {
          this.openTime(interval, true);
        }
        if (!interval.disable && interval.schedule !== null && !interval.schedule.reservation) {
          this.closeTime(interval, true);
        }
      });
      if (intervals.length) {
        this.$dialog.notify.info(`Расписание изменено`);
      }
    },
  },
});
